import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import {
  ROUTE_CLIENT_TICKETS,
} from "../../../../config/routes";
import { Row, Col } from "reactstrap";
import { TicketDetailsTable } from './view/TicketDetailsTable';

function TicketDetailsTab(props) {
  const { ticket } = props;

  return (
    <div className="ticket-detail-content">
      <div className="ticket-detail-table">
        <TicketDetailsTable ticket={ticket}/>
      </div>
      <Row className="ticket-detail-back mt-2 text-right justify-content-md-end">
        <Col lg="auto mb-2 mb-xl-0">
          <Link className="btn btn-secondary" to={ROUTE_CLIENT_TICKETS}>
            <FormattedMessage id="messages.go_back"/>
          </Link>
        </Col>
      </Row>
    </div>
  );
}

export { TicketDetailsTab };
